module.exports = __webpack_public_path__ + "static/footer-apme-adbc881d6fe1432c7a1a505bd05a90ec.png";